import { vModelText as _vModelText, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12 text-right d-flex justify-content-between" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Create New Pair ")
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" No assets. ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Loading assets data. Please wait. ")
const _hoisted_9 = { class: "badge badge-light" }
const _hoisted_10 = { class: "badge badge-light" }
const _hoisted_11 = /*#__PURE__*/_createVNode("i", { class: "fas fa-pencil-alt" }, null, -1)
const _hoisted_12 = { class: "row" }
const _hoisted_13 = {
  key: 0,
  class: "col-12"
}
const _hoisted_14 = { class: "form-group text-left" }
const _hoisted_15 = /*#__PURE__*/_createVNode("label", { for: "id" }, " Pair ", -1)
const _hoisted_16 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_17 = { class: "col-6" }
const _hoisted_18 = { class: "form-group text-left" }
const _hoisted_19 = /*#__PURE__*/_createVNode("label", { for: "baseCurrencyId" }, " Base Currency ", -1)
const _hoisted_20 = {
  key: 2,
  class: "text-danger"
}
const _hoisted_21 = { class: "col-6" }
const _hoisted_22 = { class: "form-group text-left" }
const _hoisted_23 = /*#__PURE__*/_createVNode("label", { for: "quoteCurrencyId" }, " Quote Currency ", -1)
const _hoisted_24 = {
  key: 2,
  class: "text-danger"
}
const _hoisted_25 = { class: "col-6" }
const _hoisted_26 = { class: "form-group text-left" }
const _hoisted_27 = { for: "baseCurrencyRevenuePercentage" }
const _hoisted_28 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_29 = { class: "col-6" }
const _hoisted_30 = { class: "form-group text-left" }
const _hoisted_31 = { for: "quoteCurrencyRevenuePercentage" }
const _hoisted_32 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_33 = { class: "col-12" }
const _hoisted_34 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_35 = { class: "col-12" }
const _hoisted_36 = { class: "form-check" }
const _hoisted_37 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "allowAutomaticTrade"
}, " Allow Automatic Trade ", -1)
const _hoisted_38 = {
  key: 1,
  class: "col-12 mt-2"
}
const _hoisted_39 = { class: "form-group" }
const _hoisted_40 = /*#__PURE__*/_createVNode("label", { for: "automaticExecutionProviderName" }, " Automatic Execution Provider Name ", -1)
const _hoisted_41 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_42 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_43 = {
  key: 2,
  class: "col-12"
}
const _hoisted_44 = { class: "form-group" }
const _hoisted_45 = /*#__PURE__*/_createVNode("label", { for: "B2C2 Instrument" }, " Instrument ", -1)
const _hoisted_46 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_47 = {
  key: 3,
  class: "col-6"
}
const _hoisted_48 = { class: "form-group text-left" }
const _hoisted_49 = /*#__PURE__*/_createVNode("label", { for: "minBase" }, " Minimum Base Amount ", -1)
const _hoisted_50 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_51 = /*#__PURE__*/_createTextVNode(" Provider Min. Amount: ")
const _hoisted_52 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_53 = {
  key: 2,
  class: "text-danger"
}
const _hoisted_54 = {
  key: 4,
  class: "col-6"
}
const _hoisted_55 = { class: "form-group text-left" }
const _hoisted_56 = /*#__PURE__*/_createVNode("label", { for: "minQuote" }, " Minimum Quote Amount ", -1)
const _hoisted_57 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_58 = /*#__PURE__*/_createTextVNode(" Provider Min. Amount: ")
const _hoisted_59 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_60 = {
  key: 2,
  class: "text-danger"
}
const _hoisted_61 = {
  key: 5,
  class: "col-6"
}
const _hoisted_62 = { class: "form-group text-left" }
const _hoisted_63 = /*#__PURE__*/_createVNode("label", { for: "levelLower" }, "Level Lower", -1)
const _hoisted_64 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_65 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_66 = {
  key: 6,
  class: "col-6"
}
const _hoisted_67 = { class: "form-group text-left" }
const _hoisted_68 = /*#__PURE__*/_createVNode("label", { for: "levelHigher" }, "Level Higher", -1)
const _hoisted_69 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_70 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_71 = { class: "col-3" }
const _hoisted_72 = { class: "form-check" }
const _hoisted_73 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "allowSell"
}, " Allow Sell ", -1)
const _hoisted_74 = { class: "col-3" }
const _hoisted_75 = { class: "form-check" }
const _hoisted_76 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "allowBuy"
}, " Allow Buy ", -1)
const _hoisted_77 = { class: "col-3" }
const _hoisted_78 = { class: "form-check" }
const _hoisted_79 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "isActive"
}, " Active ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_ConfirmPopup = _resolveComponent("ConfirmPopup")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Dialog = _resolveComponent("Dialog")
  const _component_CardBase = _resolveComponent("CardBase")

  return (_openBlock(), _createBlock(_component_CardBase, {
    title: "Manage Pairs",
    subtitle: "Please provide the required information.",
    allowBack: true
  }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_DataTable, {
            value: _ctx.getFilteredPairs,
            paginator: true,
            rows: 10,
            rowsPerPageOptions: [10, 20, 50],
            autoLayout: true,
            loading: _ctx.getStatus == 'fetching',
            paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
            currentPageReportTemplate: "Showing {first} to {last} of {totalRecords}"
          }, {
            header: _withCtx(() => [
              _createVNode("div", _hoisted_3, [
                _createVNode("div", _hoisted_4, [
                  _withDirectives(_createVNode("input", {
                    type: "text",
                    class: "form-control w-50",
                    placeholder: "Search...",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.mainSearch = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.mainSearch]
                  ]),
                  _createVNode("button", {
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addNewPair && _ctx.addNewPair(...args))),
                    class: "btn btn-sm btn-sky"
                  }, [
                    _hoisted_5,
                    _hoisted_6
                  ])
                ])
              ])
            ]),
            empty: _withCtx(() => [
              _hoisted_7
            ]),
            loading: _withCtx(() => [
              _hoisted_8
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Column, {
                header: "Pair",
                bodyStyle: "text-align: left"
              }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.id), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                header: "Base Currency",
                bodyStyle: "text-align: left"
              }, {
                body: _withCtx((slotProps) => [
                  _createVNode("span", _hoisted_9, _toDisplayString(slotProps.data.baseCurrencyId), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                header: "Quote Currency",
                bodyStyle: "text-align: left"
              }, {
                body: _withCtx((slotProps) => [
                  _createVNode("span", _hoisted_10, _toDisplayString(slotProps.data.quoteCurrencyId), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                header: "Base Currency Rev.",
                bodyStyle: "text-align: left"
              }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.baseCurrencyRevenuePercentage * 100) + " % ", 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                header: "Quote Currency Rev.",
                bodyStyle: "text-align: left"
              }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.quoteCurrencyRevenuePercentage * 100) + " % ", 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                header: "Allow Sell",
                bodyStyle: "text-align: left"
              }, {
                body: _withCtx((slotProps) => [
                  _createVNode("input", {
                    disabled: "",
                    type: "checkbox",
                    checked: slotProps.data.allowSell
                  }, null, 8, ["checked"])
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                header: "Allow Buy",
                bodyStyle: "text-align: left"
              }, {
                body: _withCtx((slotProps) => [
                  _createVNode("input", {
                    disabled: "",
                    type: "checkbox",
                    checked: slotProps.data.allowBuy
                  }, null, 8, ["checked"])
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                header: "Active",
                bodyStyle: "text-align: left"
              }, {
                body: _withCtx((slotProps) => [
                  _createVNode("input", {
                    disabled: "",
                    type: "checkbox",
                    checked: slotProps.data.isActive
                  }, null, 8, ["checked"])
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                header: "Allow AT",
                bodyStyle: "text-align: left"
              }, {
                body: _withCtx((slotProps) => [
                  _createVNode("input", {
                    disabled: "",
                    type: "checkbox",
                    checked: slotProps.data.allowAutomaticTrade
                  }, null, 8, ["checked"])
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                header: "Actions",
                bodyStyle: "text-align: left"
              }, {
                body: _withCtx(({data}) => [
                  _createVNode("button", {
                    onClick: ($event: any) => (_ctx.edit(data)),
                    class: "btn btn-sm btn-warning mr-3"
                  }, [
                    _hoisted_11
                  ], 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value", "loading"]),
          _createVNode(_component_ConfirmPopup),
          _createVNode(_component_Dialog, {
            header: _ctx.pairForm.props.id ? 'Edit Pair' : 'Add Pair',
            visible: _ctx.showModal,
            "onUpdate:visible": _cache[25] || (_cache[25] = ($event: any) => (_ctx.showModal = $event)),
            style: { width: '50vw' },
            modal: true
          }, {
            footer: _withCtx(() => [
              _createVNode("button", {
                disabled: 
                !_ctx.validRevenue ||
                  _ctx.pairForm.invalid ||
                  !_ctx.isValidateFormWithAllowAutomaticTrade
              ,
                class: "btn btn-success",
                onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.savePair && _ctx.savePair(...args)))
              }, " Save ", 8, ["disabled"])
            ]),
            default: _withCtx(() => [
              _createVNode("div", _hoisted_12, [
                (_ctx.pairForm.props.id)
                  ? (_openBlock(), _createBlock("div", _hoisted_13, [
                      _createVNode("div", _hoisted_14, [
                        _hoisted_15,
                        _withDirectives(_createVNode("input", {
                          id: "id",
                          type: "text",
                          class: "form-control",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.pairForm.props.id = $event)),
                          disabled: ""
                        }, null, 512), [
                          [_vModelText, _ctx.pairForm.props.id]
                        ]),
                        (_ctx.pairForm.controls.id.dirty)
                          ? (_openBlock(), _createBlock("small", _hoisted_16, _toDisplayString(_ctx.pairForm.controls.id.errorMessage), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_17, [
                  _createVNode("div", _hoisted_18, [
                    _hoisted_19,
                    (_ctx.pairForm.props.id)
                      ? _withDirectives((_openBlock(), _createBlock("input", {
                          key: 0,
                          type: "text",
                          class: "form-control",
                          disabled: "",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.pairForm.props.baseCurrencyId = $event))
                        }, null, 512)), [
                          [_vModelText, _ctx.pairForm.props.baseCurrencyId]
                        ])
                      : (_openBlock(), _createBlock(_component_Dropdown, {
                          key: 1,
                          onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getMinimumTradeSize(null))),
                          class: "w-100",
                          filter: true,
                          showClear: true,
                          modelValue: _ctx.pairForm.props.baseCurrencyId,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.pairForm.props.baseCurrencyId = $event)),
                          options: _ctx.getCurrencies,
                          optionLabel: "id",
                          optionValue: "id",
                          placeholder: "Select"
                        }, null, 8, ["modelValue", "options"])),
                    (_ctx.pairForm.controls.baseCurrencyId.dirty)
                      ? (_openBlock(), _createBlock("small", _hoisted_20, _toDisplayString(_ctx.pairForm.controls.baseCurrencyId.errorMessage), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_21, [
                  _createVNode("div", _hoisted_22, [
                    _hoisted_23,
                    (_ctx.pairForm.props.id)
                      ? _withDirectives((_openBlock(), _createBlock("input", {
                          key: 0,
                          type: "text",
                          class: "form-control",
                          disabled: "",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.pairForm.props.quoteCurrencyId = $event))
                        }, null, 512)), [
                          [_vModelText, _ctx.pairForm.props.quoteCurrencyId]
                        ])
                      : (_openBlock(), _createBlock(_component_Dropdown, {
                          key: 1,
                          onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.getMinimumTradeSize(null))),
                          class: "w-100",
                          filter: true,
                          showClear: true,
                          modelValue: _ctx.pairForm.props.quoteCurrencyId,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.pairForm.props.quoteCurrencyId = $event)),
                          options: _ctx.getCurrencies,
                          optionLabel: "id",
                          optionValue: "id",
                          placeholder: "Select"
                        }, null, 8, ["modelValue", "options"])),
                    (_ctx.pairForm.controls.quoteCurrencyId.dirty)
                      ? (_openBlock(), _createBlock("small", _hoisted_24, _toDisplayString(_ctx.pairForm.controls.quoteCurrencyId.errorMessage), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_25, [
                  _createVNode("div", _hoisted_26, [
                    _createVNode("label", _hoisted_27, " Base Currency Revenue (" + _toDisplayString(_ctx.pairForm.props.baseCurrencyRevenuePercentage * 100) + " %) ", 1),
                    _withDirectives(_createVNode("input", {
                      id: "baseCurrencyRevenuePercentage",
                      type: "number",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.pairForm.props.baseCurrencyRevenuePercentage = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.pairForm.props.baseCurrencyRevenuePercentage]
                    ]),
                    (_ctx.pairForm.controls.baseCurrencyRevenuePercentage.dirty)
                      ? (_openBlock(), _createBlock("small", _hoisted_28, _toDisplayString(_ctx.pairForm.controls.baseCurrencyRevenuePercentage.errorMessage), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_29, [
                  _createVNode("div", _hoisted_30, [
                    _createVNode("label", _hoisted_31, " Quote Currency Revenue (" + _toDisplayString(_ctx.pairForm.props.quoteCurrencyRevenuePercentage * 100) + " %) ", 1),
                    _withDirectives(_createVNode("input", {
                      id: "quoteCurrencyRevenuePercentage",
                      type: "number",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.pairForm.props.quoteCurrencyRevenuePercentage = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.pairForm.props.quoteCurrencyRevenuePercentage]
                    ]),
                    (_ctx.pairForm.controls.quoteCurrencyRevenuePercentage.dirty)
                      ? (_openBlock(), _createBlock("small", _hoisted_32, _toDisplayString(_ctx.pairForm.controls.quoteCurrencyRevenuePercentage
                      .errorMessage), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_33, [
                  (!_ctx.validRevenue)
                    ? (_openBlock(), _createBlock("small", _hoisted_34, " The percentage of Base Currency and QuoteCurrencyRevenue must add up 100% "))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_35, [
                  _createVNode("div", _hoisted_36, [
                    _withDirectives(_createVNode("input", {
                      type: "checkbox",
                      class: "form-check-input",
                      id: "allowAutomaticTrade",
                      value: true,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.pairForm.props.allowAutomaticTrade = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.pairForm.props.allowAutomaticTrade]
                    ]),
                    _hoisted_37
                  ])
                ]),
                (_ctx.pairForm.props.allowAutomaticTrade)
                  ? (_openBlock(), _createBlock("div", _hoisted_38, [
                      _createVNode("div", _hoisted_39, [
                        _hoisted_40,
                        _withDirectives(_createVNode("select", {
                          onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.getInstrumentByProvider(null))),
                          class: "form-control",
                          id: "automaticExecutionProviderName",
                          name: "automaticExecutionProviderName",
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.pairForm.props.automaticExecutionProviderName = $event))
                        }, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.providers, (p) => {
                            return (_openBlock(), _createBlock("option", {
                              key: p.id,
                              value: p.name
                            }, _toDisplayString(p.name), 9, ["value"]))
                          }), 128))
                        ], 544), [
                          [_vModelSelect, _ctx.pairForm.props.automaticExecutionProviderName]
                        ])
                      ]),
                      (_ctx.pairForm.controls.automaticExecutionProviderName.dirty)
                        ? (_openBlock(), _createBlock("small", _hoisted_41, _toDisplayString(_ctx.pairForm.controls.automaticExecutionProviderName.errorMessage), 1))
                        : _createCommentVNode("", true),
                      (_ctx.pairForm.props.automaticExecutionProviderName === null)
                        ? (_openBlock(), _createBlock("small", _hoisted_42, " This field is required "))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.pairForm.props.allowAutomaticTrade)
                  ? (_openBlock(), _createBlock("div", _hoisted_43, [
                      _createVNode("div", _hoisted_44, [
                        _hoisted_45,
                        _createVNode(_component_Dropdown, {
                          onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.getMinimumTradeSize(null))),
                          class: "w-100",
                          filter: true,
                          showClear: true,
                          modelValue: _ctx.pairForm.props.instrumentId,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.pairForm.props.instrumentId = $event)),
                          options: _ctx.b2b2Instruments,
                          optionLabel: "name",
                          optionValue: "id",
                          placeholder: "Select an Instrument"
                        }, null, 8, ["modelValue", "options"])
                      ]),
                      (_ctx.pairForm.props.instrumentId === null)
                        ? (_openBlock(), _createBlock("small", _hoisted_46, " This field is required "))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.pairForm.props.allowAutomaticTrade)
                  ? (_openBlock(), _createBlock("div", _hoisted_47, [
                      _createVNode("div", _hoisted_48, [
                        _hoisted_49,
                        _withDirectives(_createVNode("input", {
                          id: "minBase",
                          type: "number",
                          class: "form-control",
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.pairForm.props.minBase = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.pairForm.props.minBase]
                        ]),
                        (_ctx.minBaseAmount !== 0)
                          ? (_openBlock(), _createBlock("small", _hoisted_50, [
                              _hoisted_51,
                              _createVNode("b", null, _toDisplayString(_ctx.minBaseAmount) + ". ", 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.pairForm.controls.minBase.dirty)
                          ? (_openBlock(), _createBlock("small", _hoisted_52, _toDisplayString(_ctx.pairForm.controls.minBase.errorMessage), 1))
                          : _createCommentVNode("", true),
                        (_ctx.pairForm.props.minBase === null)
                          ? (_openBlock(), _createBlock("small", _hoisted_53, " This field is required "))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.pairForm.props.allowAutomaticTrade)
                  ? (_openBlock(), _createBlock("div", _hoisted_54, [
                      _createVNode("div", _hoisted_55, [
                        _hoisted_56,
                        _withDirectives(_createVNode("input", {
                          id: "minQuote",
                          type: "number",
                          class: "form-control",
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.pairForm.props.minQuote = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.pairForm.props.minQuote]
                        ]),
                        (_ctx.minQuoteAmount !== 0)
                          ? (_openBlock(), _createBlock("small", _hoisted_57, [
                              _hoisted_58,
                              _createVNode("b", null, _toDisplayString(_ctx.minQuoteAmount) + ". ", 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.pairForm.controls.minQuote.dirty)
                          ? (_openBlock(), _createBlock("small", _hoisted_59, _toDisplayString(_ctx.pairForm.controls.minQuote.errorMessage), 1))
                          : _createCommentVNode("", true),
                        (_ctx.pairForm.props.minQuote === null)
                          ? (_openBlock(), _createBlock("small", _hoisted_60, " This field is required "))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.pairForm.props.allowAutomaticTrade)
                  ? (_openBlock(), _createBlock("div", _hoisted_61, [
                      _createVNode("div", _hoisted_62, [
                        _hoisted_63,
                        _withDirectives(_createVNode("input", {
                          id: "levelLower",
                          type: "number",
                          class: "form-control",
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.pairForm.props.levelLower = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.pairForm.props.levelLower]
                        ]),
                        (_ctx.pairForm.controls.levelLower.dirty)
                          ? (_openBlock(), _createBlock("small", _hoisted_64, _toDisplayString(_ctx.pairForm.controls.levelLower.errorMessage), 1))
                          : _createCommentVNode("", true),
                        (_ctx.pairForm.props.levelLower === null)
                          ? (_openBlock(), _createBlock("small", _hoisted_65, " This field is required "))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.pairForm.props.allowAutomaticTrade)
                  ? (_openBlock(), _createBlock("div", _hoisted_66, [
                      _createVNode("div", _hoisted_67, [
                        _hoisted_68,
                        _withDirectives(_createVNode("input", {
                          id: "levelHigher",
                          type: "number",
                          class: "form-control",
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.pairForm.props.levelHigher = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.pairForm.props.levelHigher]
                        ]),
                        (_ctx.pairForm.controls.levelHigher.dirty)
                          ? (_openBlock(), _createBlock("small", _hoisted_69, _toDisplayString(_ctx.pairForm.controls.levelHigher.errorMessage), 1))
                          : _createCommentVNode("", true),
                        (_ctx.pairForm.props.levelHigher === null)
                          ? (_openBlock(), _createBlock("small", _hoisted_70, " This field is required "))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_71, [
                  _createVNode("div", _hoisted_72, [
                    _withDirectives(_createVNode("input", {
                      type: "checkbox",
                      class: "form-check-input",
                      id: "allowSell",
                      value: true,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.pairForm.props.allowSell = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.pairForm.props.allowSell]
                    ]),
                    _hoisted_73
                  ])
                ]),
                _createVNode("div", _hoisted_74, [
                  _createVNode("div", _hoisted_75, [
                    _withDirectives(_createVNode("input", {
                      type: "checkbox",
                      class: "form-check-input",
                      id: "allowBuy",
                      value: true,
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.pairForm.props.allowBuy = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.pairForm.props.allowBuy]
                    ]),
                    _hoisted_76
                  ])
                ]),
                _createVNode("div", _hoisted_77, [
                  _createVNode("div", _hoisted_78, [
                    _withDirectives(_createVNode("input", {
                      type: "checkbox",
                      class: "form-check-input",
                      id: "isActive",
                      value: true,
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.pairForm.props.isActive = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.pairForm.props.isActive]
                    ]),
                    _hoisted_79
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["header", "visible"])
        ])
      ])
    ]),
    _: 1
  }))
}